import styled from "styled-components";
import {BurgerIconDefaultBox} from "./burger-icon.default.box";

export const BurgerIconSiBox = styled(BurgerIconDefaultBox)`
  height: 20px;
  background-position: -974px -646px;
`